<template>
  <base-modal>
    <div class="mb-4">
      {{ $t('autocaller_v2.task.modal.import_hint') }}
    </div>
    <file-upload :is_loading="loading" @before_upload="before_upload" />
    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :disabled="loading || !upload_file.name"
      :loading="loading"
      @click="save"
    >
      {{ $t('shared.component.button.import') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import FileUpload from '@autocaller_v2/components/tasks/file-upload';
  import { TaskService } from '@autocaller_v2/services/TaskService';

  export default {
    components: {
      BaseModal,
      FileUpload
    },

    data: () => ({
      loading: false,
      upload_file: {}
    }),

    methods: {
      before_upload: function (file) {
        this.upload_file = file;
      },
      save() {
        const file = this.upload_file;
        this.loading = true;

        const formData = new FormData();
        formData.append('file', file);

        const campaign_id = this.$route.params.id;
        
        return TaskService.upload(campaign_id, formData)
          .then((response) => {
            this.$noty.success(this.$t('hlr.requests.upload.success'));
            this.$emit('success', response);
          })
          .catch((e) => {
            this.$noty.task_import_error(e);
            this.$emit('fail', e);
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
